import * as Constants from '../Constant';

const initialState = {
    message: {},
    prescriptionList: [],
    prescriptionData: {},
    presId: "",
    prescriptionDetails: {}
}

export default function prescriptionReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.CREATE_PRESCRIPTION:
            return {
                ...state,
                prescriptionData: action.payload,
            }
        case Constants.POST_PRESCRIPTION:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_PRESCRIPTION:
            return {
                ...state,
                prescriptionList: action.payload,
                presId: action.presId
            }
        case Constants.UPDATE_PRESCRIPTION:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.DELETE_PRESCRIPTION:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.PRESCRIPTION_DETAILS:
            return {
                ...state,
                prescriptionDetails: action.payload,
            }
        case Constants.RESET:
            return {
                ...initialState,
            }
        default:
            return state;
    }
}